import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryEnergyRenovationIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-category-energy-renovation"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-brand-primary"
      d="M17.7426 2.73445C17.7426 2.2892 17.3826 1.93396 16.9421 1.93396H15.2795C14.839 1.93396 14.479 2.2892 14.479 2.73445V4.64613C14.479 4.70985 14.5094 4.76976 14.5608 4.80744L17.4243 6.90627C17.5564 7.0031 17.7426 6.90876 17.7426 6.74496V2.73445Z"
    />
    <path
      className="fill-accent-primaryActive"
      d="M21.4837 11.3564C21.3429 11.5485 21.1248 11.6502 20.9038 11.6502C20.7563 11.6502 20.6078 11.6051 20.4799 11.5113L11.7985 5.15185C11.4467 4.89413 10.9684 4.89413 10.6166 5.15185L1.93525 11.5113C1.61536 11.7457 1.16595 11.6765 0.931433 11.3564C0.696887 11.0363 0.766329 10.5869 1.08645 10.3525L10.7831 3.24911C11.0357 3.06394 11.3794 3.06394 11.6319 3.24911L21.3287 10.3525C21.6488 10.5869 21.7182 11.0363 21.4837 11.3564Z"
    />
    <path
      className="fill-brand-primary"
      d="M14.7477 7.90153L14.4806 7.70228L11.7975 5.73916C11.4457 5.48174 10.9676 5.4819 10.616 5.73955L3.31523 11.0886C3.05815 11.277 2.90625 11.5766 2.90625 11.8953V21.1151C2.90625 21.6449 3.33191 22.066 3.85721 22.066H18.5606C19.0813 22.066 19.5115 21.6449 19.5115 21.1151V11.8956C19.5115 11.5767 19.3594 11.277 19.1021 11.0887L14.7477 7.90153Z"
    />
    <path
      className="fill-accent-primaryActive"
      d="M20.8705 18.7157L23.0703 16.5073C23.147 16.4302 23.1495 16.3064 23.0759 16.2263L22.1713 15.2421L20.8705 13.8436C20.5456 13.4987 20.1232 13.3071 19.6791 13.3071H8.85702C8.57638 13.3071 8.34888 13.5346 8.34888 13.8153V18.7504C8.34888 19.031 8.57638 19.2585 8.85703 19.2585H19.6791C20.1232 19.2585 20.5456 19.0669 20.8705 18.7157Z"
    />
    <path
      d="M15.7912 18.6069L15.5622 17.7353H14.0512L13.8157 18.6069H12.4351L13.9525 13.937H15.629L17.1655 18.6069H15.7912ZM15.3013 16.7046L15.1009 15.9411C15.0543 15.7715 14.997 15.552 14.9292 15.2826C14.8634 15.0133 14.8199 14.8203 14.7987 14.7036C14.7796 14.8118 14.7415 14.9899 14.6842 15.2381C14.6291 15.4862 14.505 15.975 14.312 16.7046H15.3013Z"
      fill="white"
    />
  </Svg>
));

CategoryEnergyRenovationIcon.displayName = 'CategoryEnergyRenovationIcon';
